import i18n from '../i18n';

/**
 * Format a number as currency using the current i18n language.
 * Defaults: EUR. Override via the currency parameter if needed per context.
 */
export function formatCurrency(
  amount: number,
  currency: string = 'EUR',
  options: Intl.NumberFormatOptions = {}
): string {
  const lang = (i18n.language || 'en').split('-')[0];
  return new Intl.NumberFormat(lang, {
    style: 'currency',
    currency,
    ...options,
  }).format(amount);
}

/**
 * Format a date using the current i18n language.
 * Defaults to dd/MM/yyyy style via day/month/year 2-digit.
 */
export function formatDate(
  input: Date | string | number,
  options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' }
): string {
  const lang = (i18n.language || 'en').split('-')[0];
  const date = input instanceof Date ? input : new Date(input);
  return new Intl.DateTimeFormat(lang, options).format(date);
}

/**
 * Format a date and time using current i18n language.
 * Convenient helper for common date+time displays.
 */
export function formatDateTime(
  input: Date | string | number,
  options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }
): string {
  const lang = (i18n.language || 'en').split('-')[0];
  const date = input instanceof Date ? input : new Date(input);
  return new Intl.DateTimeFormat(lang, options).format(date);
}